__turbopack_context__.v({
  "actions": "similar-listings-module__YqtR2W__actions",
  "art": "similar-listings-module__YqtR2W__art",
  "body": "similar-listings-module__YqtR2W__body",
  "buy": "similar-listings-module__YqtR2W__buy",
  "card": "similar-listings-module__YqtR2W__card",
  "cardLink": "similar-listings-module__YqtR2W__cardLink",
  "empty": "similar-listings-module__YqtR2W__empty",
  "grid": "similar-listings-module__YqtR2W__grid",
  "header": "similar-listings-module__YqtR2W__header",
  "modal": "similar-listings-module__YqtR2W__modal",
  "name": "similar-listings-module__YqtR2W__name",
  "price": "similar-listings-module__YqtR2W__price",
  "root": "similar-listings-module__YqtR2W__root",
  "skeleton": "similar-listings-module__YqtR2W__skeleton",
  "traits": "similar-listings-module__YqtR2W__traits",
  "usd": "similar-listings-module__YqtR2W__usd",
  "viewAll": "similar-listings-module__YqtR2W__viewAll",
});
